import React from 'react';

import {Sequence} from 'biojs/Sequence';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface InsertPartSequenceProps {
  getPath: (s: Sequence) => string;
  sequence: Sequence;
}

function InsertPartSequence({getPath, sequence}: InsertPartSequenceProps): JSX.Element {
  return (
    <div className="part-sequence-preview">
      <div className="row">
        <div className="col col-md-12">
          <span className="name">{sequence.get('name')}</span>
          <span className="folder faded"> {getPath(sequence)}</span>
          <span className="pull-right">
            {sequence.get('length')}bp &middot;{' '}
            <span className="topology">{sequence.get('circular') ? 'circular' : 'linear'}</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<InsertPartSequenceProps>(InsertPartSequence);
